import * as jschardet from 'jschardet';

/**
 * Lit un fichier CSV en détectant son encodage (latin1 / UTF-8…) — cas gelé T19.
 * Même stratégie que l'ancien composant : détection sur le premier Ko, décodage complet.
 * @param {File} file
 * @returns {Promise<string>}
 */
export async function readCsvFile(file) {
    const head = await file.slice(0, 1024).arrayBuffer();
    let encoding = 'UTF-8';
    try {
        const binary = Array.from(new Uint8Array(head), (b) => String.fromCharCode(b)).join('');
        const detected = jschardet.detect(binary);
        if (detected?.encoding) encoding = detected.encoding;
    } catch (e) {
        // fallback UTF-8
    }

    const buffer = await file.arrayBuffer();
    try {
        return new TextDecoder(encoding).decode(new Uint8Array(buffer));
    } catch (e) {
        // encodage non supporté par TextDecoder → UTF-8
        return new TextDecoder('UTF-8').decode(new Uint8Array(buffer));
    }
}

export default readCsvFile;
